
// Inquiry presence error message
const contactForm = document.getElementById("contact-form");
if (contactForm) {
  /*contactForm.addEventListener("submit", function(e) {
    const errorMessage = "Please select an inquiry.";
    const subject = form.querySelector(".select-selected").innerHTML
    const labelSpan = form.children[0].querySelector('label');
    const inquiryRow = form.children[0];

    if (subject === "Please Select" && labelSpan.innerHTML === "Inquiry *") {
      e.preventDefault();
      if (inquiryRow.childElementCount === 2) {
        inquiryRow.insertAdjacentHTML(
          "beforeend",
          `<p>${errorMessage}</p>`
          );
      }
    }
  });*/

  const selectItems = document.querySelector('.select-items');
  selectItems.addEventListener("click", function(e) {
    const inquiryRow = this.parentNode.parentNode;

    const errorElements = inquiryRow.getElementsByTagName("p");
    if (errorElements.length) {
      errorElements[0].remove();
    }
  });

  // Change form button after successful submit
  // const contactForm = document.getElementById('contact-form');
  contactForm.addEventListener('ajax:success', (e) => {
    if (e.detail[0].status == 'success') {
      const inputs = [
        '#contact_name',
        '#contact_email',
        '#contact_message',
      ];
      for(let input of inputs) {
        contactForm.querySelector(input).value = '';
      }
      contactForm.querySelector('#combo1').innerHTML = 'Please select';
      contactForm.querySelector('input[type=submit]').style.display = 'none';
      contactForm.querySelector('.thank-you').style.display = 'block';
      contactForm.querySelectorAll('input, textarea').forEach((f) => f.setAttribute('disabled', true));
    }
  });
}
